import React, { Component } from 'react'
import { css } from 'emotion'

class CFButton extends Component {
  render() {
    const { className, children, disabled, ...props } = this.props
    const classNames = css(styles.button, className)
    return (
      <button className={classNames} disabled={disabled} {...props}>
        {children}
      </button>
    )
  }
}

const styles = {
  button: css({
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    margin: 0,
    padding: 0,
    width: 'auto',
    overflow: 'visible',
    background: 'transparent',
    color: 'inherit',
    font: 'inherit',
    lineHeight: 'normal',
    textAlign: 'inherit',
  }),
}

export default CFButton
